import angular from 'angular';
import 'angular-ui-router';

import templateFaq from './faq';
import templateFaq2 from './faq2';
import templateMaster from './master';
import { templateBuilder } from './builder';

const exportConst = angular.module('templates', [
    'ui.router',
    templateFaq,
    templateFaq2,
    templateMaster,
    templateBuilder,
]).name;

export default exportConst;
